import { baseAction } from '../../utilityFunctions';
import { ADD_DRAWER, REMOVE_DRAWER, UPDATE_DRAWER } from './actionTypes';

export const addDrawer = (data) => baseAction(ADD_DRAWER, data);

export const removeDrawer = (data) => baseAction(REMOVE_DRAWER, data);

export const updateDrawer = (data) => baseAction(UPDATE_DRAWER, data);
